import React, { FC, useState } from "react";
import useAppStore from "../Store/AppStore";
import { useTranslation } from "react-i18next";

import "./LineFilter.scss";
import ArrowUp from "../../assets/Arrow.svg";
import Rails from "../../assets/Rails.svg";

const FilterMenu: FC = () => {
  const { t } = useTranslation();

  const lineFilterValues = useAppStore((state) => state.lineFilterValues);
  const select = useAppStore((state) => state.toggleLineFilter);

  const [isDropdownOpen, setDropdownOpen] = useState(false);

  return (
    <>
      <label
        className="line-label mb-1 pt-2 uppercase text-xs text-grayLabel font-black"
        htmlFor="linie"
      >
        {t("Linie")}
      </label>

      <div className="line-input-wrapper relative xl:w-[175px]">
        <button
          className="flex justify-between items-center w-full p-1 bg-white border border-gray550"
          onClick={() => setDropdownOpen(!isDropdownOpen)}
        >
          <div className="flex items-center">
            <img src={Rails} className="w-[18px] h-[18px]" />
            <p className="line-text-input h-[20px] w-[120px] pt-[2px] pl-[10px] text-xs text-start text-ellipsis overflow-hidden whitespace-nowrap ">
              {lineFilterValues.every(
                (lf) => lf.selected === false || lf.selected === undefined
              )
                ? t("all")
                : lineFilterValues
                    .filter((lf) => lf.selected === true)
                    .map((lf) => lf.label)
                    .join(", ")}
            </p>
          </div>
          <img
            className="line-arrow-icon"
            src={ArrowUp}
            style={{
              transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0)",
            }}
            alt="Arrow Icon"
          />
        </button>
        {isDropdownOpen && (
          <ul className="line-dropdown absolute top-10 z-10 xl:w-full bg-white rounded-md p-2">
            {lineFilterValues.map((option, index) => (
              <li
                key={index}
                className="flex items-start my-2"
                onClick={() => select(option.id)}
              >
                <input
                  type="checkbox"
                  className="form-checkbox mr-2"
                  checked={option.selected}
                />
                <span className="text-xs">{option.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default FilterMenu;
